import { useState } from "react";
import { LogOut, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Field, Spinner } from "@/components/Shared";
import { Link } from "react-router-dom";

export default function Account() {
  const { user, logout } = useAuth();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const change = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Password updated");
      setCur(""); setPw("");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-xl fade-up">
      <PageHeader eyebrow="Account" title={user?.name} />
      <div className="panel mb-5 divide-y divide-border" data-testid="account-profile">
        {[["Email", user?.email], ["Role", user?.role === "admin" ? "Admin / Owner" : "Employee"], ["Craft", user?.craft], ["Phone", user?.phone || "—"]].map(([k, v]) => (
          <div key={k} className="flex items-center justify-between px-4 py-3 text-sm">
            <span className="text-slate-500">{k}</span><span className="font-semibold text-slate-900">{v}</span>
          </div>
        ))}
      </div>
      <form onSubmit={change} className="panel space-y-4 p-4">
        <p className="flex items-center gap-2 font-display text-xl font-semibold"><KeyRound className="h-5 w-5 text-[#5C241E]" />Change password</p>
        <Field label="Current password"><input type="password" className="field-input" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="account-current-password" /></Field>
        <Field label="New password" hint="At least 8 characters"><input type="password" className="field-input" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="account-new-password" /></Field>
        <button className="btn-brand h-12 w-full sm:w-auto" disabled={busy || !cur || pw.length < 8} data-testid="account-change-password-button">{busy && <Spinner className="text-white" />}Update password</button>
      </form>
      <button onClick={logout} className="btn-ghost mt-5 h-14 w-full text-red-700" data-testid="account-logout-button"><LogOut className="h-5 w-5" />Sign out</button>
      <p className="mt-4 text-center text-sm"><Link to="/privacy" className="font-semibold text-[#5C241E] hover:underline" data-testid="account-privacy-link">Employee privacy notice</Link></p>
      <p className="mt-3 text-center"><a href="https://builtby-ab.com" target="_blank" rel="noopener noreferrer" className="text-[11px] text-slate-600 hover:text-[#5C241E]" data-testid="account-built-by-ab-link">built by ab</a></p>
    </div>
  );
}
